import { last } from 'lodash';

export const getFileType = (filename) => {
  if (!filename) {
    return null;
  }
  let type = null;

  const extension = last(filename.split('.'));
  switch (extension) {
    case 'pdf':
      type = 'application/pdf;charset=utf-8';
      break;
    case 'doc':
      type = 'application/msword';
      break;
    case 'docx':
      type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'xls':
      type = 'application/vnd.ms-excel';
      break;
    case 'xlsx':
      type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      break;
    case 'xodt':
      type = 'application/vnd.collabio.xodocuments.document';
      break;
    case 'xods':
      type = 'application/vnd.collabio.xodocuments.spreadsheet';
      break;
    case 'zip':
      type = 'application/zip';
      break;
    case 'jpg':
    case 'jpeg':
      type = 'image/jpeg';
      break;
    case 'png':
      type = 'image/png';
      break;
  }
  return type;
};
